import { styled as e } from "styled-components";
//#region src/components/Chip/styled/Chip.styled.ts
var t = e.span`
    display: inline-flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(.75)};
    padding: ${({ theme: e }) => `${e.spacing(.5)} ${e.spacing(1.5)}`};
    border-radius: ${({ theme: e }) => e.radii.full};
    background-color: ${({ theme: e }) => e.colors.accent};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    white-space: nowrap;
    line-height: 1;
`, n = e.span`
    display: inline-flex;
    align-items: center;
    margin-inline-start: ${({ theme: e }) => e.spacing(.25)};
    margin-inline-end: ${({ theme: e }) => e.spacing(-.75)};

    button {
        width: 20px;
        height: 20px;
        min-height: 0;
        padding: 0;
    }
`;
//#endregion
export { n as RemoveSlot, t as StyledChip };
